module.exports = __webpack_public_path__ + "5c65500af82d244f115d803b2796a05a.MP3";